import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PolteqTextField = _resolveComponent("PolteqTextField")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_PolteqButton = _resolveComponent("PolteqButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    id: "forgotPasswordForm",
    ref: "forgotPasswordForm"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.emailaddress,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailaddress) = $event)),
            "field-id": "usernameField",
            label: _ctx.i18n.t('fields.emailaddress'),
            rules: [_ctx.rules.email],
            type: "email",
            autocomplete: "username",
            icon: "mdi-email-outline",
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.resetPassword(_ctx.emailaddress)), ["enter"]))
          }, null, 8, ["modelValue", "label", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { style: {"text-align":"end"} }, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqButton, {
            "button-id": "resetPasswordButton",
            icon: "mdi-email-arrow-right-outline",
            "button-text": _ctx.i18n.t('buttons.resetpassword'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetPassword(_ctx.emailaddress)))
          }, null, 8, ["button-text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}